export const PROJECTS_TRANSLATION_KEY = 'user-panel-projects';
